import { GlobalMenu } from '@components';
import { ITag } from '@models/Tag.model';
import { removeTag } from '@services/queries/tags';
import { useQueryClient, useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { Container } from './TagsDetailsMenu.styles';

interface ITagsDetailsMenu {
  tag: Pick<ITag, 'id'>;
  onClose: () => void;
}

const TagsDetailsMenu = ({ tag, onClose }: ITagsDetailsMenu) => {
  const queryClient = useQueryClient();

  const params = useParams<{
    equipmentId: string;
    softwareId: string;
    miscellaneousId: string;
    studioServiceId: string;
  }>();
  const mutationRemoveTag = useMutation(removeTag, {
    onSuccess: () => {
      queryClient.invalidateQueries(['equipments', params.equipmentId]);
      onClose;
    },
  });

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Remove Tag',
            iconName: 'delete',
            onClick: () => {
              mutationRemoveTag.mutate({
                tagId: tag.id,
                equipmentId: params.equipmentId,
                softwareId: params.softwareId,
                miscellaneousId: params.miscellaneousId,
                studioServiceId: params.studioServiceId,
              });
            },
          },
        ]}
      />
    </Container>
  );
};

export { TagsDetailsMenu };
